import {
  GalleryIcon,
  ImageResolutionIcon,
  SoloPhotoIcon,
  UploadModalIcon,
  VisibleFaceIcon,
} from "assets/icons";
import Button from "components/BaseWidgets/button";
import Modal from "components/BaseWidgets/modal";
import "./style.scss";

function UploadGuideModal({ open, onCancel, onOk, title, description }) {
  const guideItems = [
    {
      icon: <VisibleFaceIcon />,
      title: "Visible face",
      description:
        "Your face should be clearly visible, without sunglasses or heavy filters.",
    },
    {
      icon: <SoloPhotoIcon />,
      title: "Solo photo",
      description:
        "Only you should be in the picture (no group photos or collages).",
    },
    {
      icon: <GalleryIcon />,
      title: "Appropriate background",
      description: "Avoid blurry, dark, or heavily edited backgrounds.",
    },
    {
      icon: <ImageResolutionIcon />,
      title: "Image resolution & format",
      description:
        "Recommended 1080x1920 pixels or higher for better quality in 4x6 ratio. Supported formats: JPG, JPEG.",
    },
  ];
  return (
    <Modal
      isOpen={open}
      className="upload-guide-modal"
      rootClassName="upload-guide-modal"
      onCancel={onCancel}
      title=""
      width={464}
      footer={null}
      closable
    >
      <div className="modal-content">
        <UploadModalIcon />
        <h2 className="font-title-xl">{title}</h2>
        <p className="modal-description mt-3">{description}</p>
        <div className="flex flex-col gap-4 mt-6 mb-8">
          {guideItems.map((item, index) => (
            <div key={index} className="content-frame flex">
              <span className="logo-wrapper">{item.icon}</span>
              <div className="heading-wrapper flex flex-col">
                <p className="title">{item.title}</p>
                <p className="font-body-normal fw-400">{item.description}</p>
              </div>
            </div>
          ))}
        </div>

        <Button className="modal-btn" onClick={onOk}>
          OK
        </Button>
      </div>
    </Modal>
  );
}

export default UploadGuideModal;
